import {
  Avatar,
  Badge,
  Card,
  CardActions,
  CardContent,
  Chip,
  CircularProgress,
  Divider,
  FormControl,
  ListItem,
  ListItemAvatar,
  ListItemText,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
  Box,
  Grid,
  Button,
  Dialog
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles, withStyles } from "@material-ui/styles";
import { captureException } from "@sentry/react";
import clsx from "clsx";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearToastAction, toastAction } from "../../../../actions";
import api from "../../../../utils/api";
import getAvatarStyle from "../../../../utils/getAvatarStyle";
import getInitials from "../../../../utils/getInitials";
import Loader from "../../../../utils/loader";

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 700
  },
  nameCell: {
    display: "flex",
    alignItems: "center"
  },
  avatar: {
    height: 42,
    width: 42,
    marginRight: theme.spacing(1)
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: "flex-end"
  },
  capitalize: {
    textTransform: "capitalize"
  },
  chipButton: {
    paddingLeft: 12,
    paddingRight: 12
  },
  tableCell: {
    paddingLeft: 8,
    paddingRight: 8
  },
  bold: {
    fontWeight: "bold"
  },
  requested: {
    backgroundColor: "red"
  },
  accepted: {
    backgroundColor: "green"
  },
  checkedOut: {
    backgroundColor: "grey"
  },
  checkedIn: {
    backgroundColor: "blue"
  },
  cancelled: {
    backgroundColor: "brown"
  },
  filterTextField: {
    "&::placeholder": {
      color: "#000"
    },
    "&::-ms-input-placeholder ": {
      color: "#000"
    }
  }
}));

const columns = [
  {
    label: "Log Id",
    dataType: "text",
    field: "logs_id"
  },
  {
    label: "Member Name",
    dataType: "text",
    field: "name"
  },
  {
    label: "Id card",
    dataType: "text",
    field: "member_workid"
  },
  {
    label: "In Time",
    dataType: "text",
    field: "in_time"
  },
  {
    label: "Out Time",
    dataType: "text",
    field: "out_time"
  },
  {
    label: "Photo",
    dataType: "photo",
    field: "image"
  }
];

const StyledBadge = withStyles(theme => ({
  badge: {
    right: -48,
    top: 10,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px"
  }
}))(Badge);

const Results = props => {
  const { className, ...rest } = props;
  const classes = useStyles();
  const user = useSelector(state => state.user);
  const orgSettings = useSelector(state => state.orgSettings);
  const [loading, setLoading] = useState(true);
  const [suggestionLoading, setSuggestionLoading] = useState(false);
  const [openSuggestion, setOpenSuggestion] = useState(false);
  const [suggestionList, setSuggestionList] = useState([]);
  const [imageModal, setImageModal] = useState(false);
  const [imageModalurl, setImageModalurl] = useState("");
  const [filterEmail, setFilterEmail] = useState("");
  const [meetings, setMeetings] = useState([]);
  const [meetingCount, setMeetingCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filters, setFilters] = useState({});
  const [currentSort, setCurrentSort] = useState({
    label: "Date & time",
    direction: "desc"
  });
  const [query, setQuery] = useState({
    search: [],
    sort: { key: "telpoData.logs_id", order: "DESC" },
    skip: 0,
    take: 10
  });

  let navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    handleQuery();
  }, [page, rowsPerPage]);

  const renderFilterColumns = (column, i) => {
    switch (column.dataType) {
      case "profile":
        return (
          <TableCell key={i} style={{ paddingLeft: 8, paddingRight: 8 }}>
            <Autocomplete
              fullWidth
              open={openSuggestion}
              blurOnSelect
              clearOnBlur
              noOptionsText={"No user found"}
              options={suggestionList}
              loading={suggestionLoading}
              onOpen={() => {
                setOpenSuggestion(true);
              }}
              onClose={() => {
                setOpenSuggestion(false);
              }}
              onChange={(event, newValue) => {
                if (newValue) {
                  setQuery({
                    ...query,
                    search: [
                      ...query.search.filter(
                        item => item.key !== "telpoData.createdBy"
                      ),
                      {
                        key: "telpoData.createdBy",
                        value: newValue.id,
                        comparison: "="
                      }
                    ]
                  });
                  setFilters({ ...filters, User: newValue.name });
                }
              }}
              filterOptions={(options, state) => options}
              getOptionLabel={option => {
                return option.name;
              }}
              renderOption={item => (
                <ListItem dense disableGutters style={{ overflowX: "hidden" }}>
                  <ListItemAvatar>
                    <Avatar style={getAvatarStyle(item.email)}>
                      {getInitials(item.name)}
                    </Avatar>
                  </ListItemAvatar>

                  <ListItemText
                    primary={
                      <StyledBadge
                        badgeContent={item.role ? item.role : "Visitor"}
                        color={item.role ? "primary" : "secondary"}
                      >
                        <Typography variant="h5">{item.name}</Typography>
                      </StyledBadge>
                    }
                    secondary={
                      <Typography variant="body2" color="textSecondary">
                        {item.role &&
                          item[orgSettings.employeePrimaryIdentifier]}
                        {!item.role &&
                          item[orgSettings.visitorPrimaryIdentifier]}
                      </Typography>
                    }
                  />
                </ListItem>
              )}
              renderInput={params => (
                <TextField
                  {...params}
                  className={classes.filterTextField}
                  placeholder="Search user by email or phone number"
                  variant="outlined"
                  onChange={e => {
                    setFilterEmail(e.target.value);
                  }}
                  value={filterEmail}
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {suggestionLoading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    )
                  }}
                />
              )}
            />
          </TableCell>
        );
      case "datetimerange":
        return (
          <TableCell key={i} style={{ paddingLeft: 8, paddingRight: 8 }}>
            <TextField
              type="date"
              size="small"
              margin="none"
              variant="outlined"
              placeholder="Filter by date"
              onChange={e => {
                setQuery({
                  ...query,
                  search: [
                    ...query.search.filter(
                      item => item.key !== "telpoData.startTime"
                    ),
                    {
                      key: "telpoData.startTime",
                      value: moment(e.target.value)
                        .endOf("day")
                        .utc()
                        .format("MM-DD-YYYY HH:mm"),
                      comparison: "<="
                    },
                    {
                      key: "telpoData.startTime",
                      value: moment(e.target.value)
                        .startOf("day")
                        .utc()
                        .format("MM-DD-YYYY HH:mm"),
                      comparison: ">"
                    }
                  ]
                });
                setFilters({
                  ...filters,
                  Date: e.target.value
                });
              }}
              required
              fullWidth
            />
          </TableCell>
        );
      case "datetime":
        return (
          <TableCell key={i} style={{ paddingLeft: 8, paddingRight: 8 }}>
            <TextField
              type="date"
              size="small"
              margin="none"
              variant="outlined"
              placeholder="Filter by date"
              onChange={e => {
                setQuery({
                  ...query,
                  search: [
                    ...query.search.filter(
                      item => item.key !== "telpoData.createdAt"
                    ),
                    {
                      key: "telpoData.createdAt",
                      value: moment(e.target.value)
                        .endOf("day")
                        .utc()
                        .format("MM-DD-YYYY HH:mm"),
                      comparison: "<="
                    },
                    {
                      key: "telpoData.createdAt",
                      value: moment(e.target.value)
                        .startOf("day")
                        .utc()
                        .format("MM-DD-YYYY HH:mm"),
                      comparison: ">"
                    }
                  ]
                });
                setFilters({
                  ...filters,
                  "Requested on": e.target.value
                });
              }}
              required
              fullWidth
            />
          </TableCell>
        );
      case "photo":
        return (
          <TableCell
            key={i}
            style={{ paddingLeft: 8, paddingRight: 8 }}
          ></TableCell>
        );
      default:
        return (
          <TableCell key={i} style={{ paddingLeft: 8, paddingRight: 8 }}>
            <TextField
              type="text"
              className={classes.filterTextField}
              size="small"
              margin="none"
              variant="outlined"
              placeholder={"Filter by " + column.label.toLowerCase()}
              required
              fullWidth
              onChange={e => {
                setQuery({
                  ...query,
                  search: [
                    ...query.search.filter(
                      item => item.key !== "telpoData." + column.field
                    ),
                    {
                      key: "telpoData." + column.field,
                      value: e.target.value,
                      comparison: "LIKE"
                    }
                  ]
                });
                setFilters({
                  ...filters,
                  [column.label]: e.target.value
                });
              }}
            />
          </TableCell>
        );
    }
  };
  const renderDataColumns = (data, columns) => {
    return columns.map((item, i) => {
      var dataField = item.field.split(".").reduce((ox, ix) => ox[ix], data);
      switch (item.dataType) {
        case "datetime":
          return dataField ? (
            <TableCell size="small" className={classes.tableCell} key={i}>
              <b>
                {moment
                  .utc(new Date(parseInt(dataField)).toISOString())
                  .local()
                  .format("LT")}
              </b>{" "}
              {moment
                .utc(new Date(parseInt(dataField)).toISOString())
                .local()
                .format("Do MMM YYYY")}
            </TableCell>
          ) : (
            <TableCell size="small" className={classes.tableCell} key={i}>
              Not Available
            </TableCell>
          );
        case "temperature":
          return (
            <TableCell
              align="center"
              size="small"
              key={i}
              className={clsx(classes.capitalize, classes.tableCell)}
            >
              {dataField}&#8451;
            </TableCell>
          );
        case "photo":
          return (
            <TableCell
              align="center"
              size="small"
              key={i}
              className={clsx(classes.capitalize, classes.tableCell)}
            >
              <img style={{ maxHeight: 60 }} src={dataField} />
            </TableCell>
          );
        default:
          return (
            <TableCell size="small" className={classes.tableCell} key={i}>
              {dataField}
            </TableCell>
          );
      }
    });
  };

  const handleChangePage = (event, page) => {
    setQuery({ ...query, skip: page * rowsPerPage });
    setPage(page);
  };

  const handleChangeRowsPerPage = event => {
    setQuery({ ...query, skip: 0, take: event.target.value });
    setRowsPerPage(event.target.value);
  };

  const handleSort = label => {
    var direction = "asc";
    var key;
    if (currentSort.label === label && currentSort.direction === "asc")
      direction = "desc";
    const order = direction.toUpperCase();

    key = columns.find(item => item.label === label).field;

    // switch (label.toLowerCase()) {
    //   case "date & time":
    //     key = "telpoData.startTime";
    //     break;
    //   case "requested at":
    //     key = "telpoData.createdAt";
    //     break;
    //   case "purpose":
    //     key = "telpoData.purpose";
    //     break;
    //   case "status":
    //     key = "telpoData.status";
    //     break;
    //   default:
    //     break;
    // }
    handleQuery({ ...query, sort: { key, order }, skip: 0 });
    setQuery({ ...query, sort: { key, order }, skip: 0 });
    setCurrentSort({ label, direction });
  };

  const handleDeleteChip = async key => {
    let field = columns.find(item => item.label === key)?.field;
 
    switch (key) {
      case "User":
        setQuery({
          ...query,
          search: [
            ...query.search.filter(item => item.key !== "telpoData.createdBy")
          ]
        });
        setFilterEmail("");
        break;
      case "Date":
        setQuery({
          ...query,
          search: [
            ...query.search.filter(item => item.key !== "telpoData.startTime")
          ]
        });
        break;
      default:
        setQuery({
          ...query,
          search: [...query.search.filter(item => item.key !== `telpoData.${field}`)]
        });
        break;
    }

    let allFilters = filters;
    delete allFilters[key];
    Object.keys(allFilters).length === 0 &&
      handleQuery({
        ...query,
        search: []
      });
    setFilters({ ...allFilters });
  };

  const handleRowClick = index => {
    // console.log(meetings[index]);
    setImageModalurl(meetings[index].image);
    setImageModal(true);
  };

  const handleQuery = async customQuery => {
    dispatch(
      toastAction({
        status: true,
        message: "Loading...",
        type: "info",
        noIcon: true
      })
    );
    try {
      const meetingCountData = customQuery
        ? await api("POST", "telpoAccessLog/findCount", customQuery, true)
        : await api("POST", "telpoAccessLog/findCount", query, true);
      const meetingData = customQuery
        ? await api("POST", "telpoAccessLog/find", customQuery, true)
        : await api("POST", "telpoAccessLog/find", query, true);
      setMeetingCount(meetingCountData);
      setMeetings(meetingData);
      setLoading(false);
      dispatch(clearToastAction({}));
    } catch (error) {
      dispatch(clearToastAction({}));
      captureException(error);
    }
  };

  const handleReport = async () => {
    const orderReportUrl = await api(
      "POST",
      "telpoAccessLog/findOrderReport",
      query,
      true
    );
    window.open(orderReportUrl, "_blank");
  };

  return loading ? (
    <Loader />
  ) : (
    <div {...rest} className={clsx(classes.root, className)}>
      <Box px={1.5} py={1}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <Grid item>
            <Typography color="textSecondary" variant="h5">
              {query.search.length === 0
                ? "All Attendance"
                : "Filtered results"}
            </Typography>
            <Typography color="textSecondary" gutterBottom variant="caption">
              {meetingCount} Results found. Page {page + 1} of{" "}
              {Math.ceil(meetingCount / rowsPerPage)}
            </Typography>
          </Grid>
          <Grid item>
            <Button onClick={handleReport} variant="outlined" color="primary">
              Download Report
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Divider />
      <Card>
        <Divider />
        <CardContent className={classes.content}>
          <PerfectScrollbar>
            <div className={classes.inner}>
              <Table>
                <TableHead>
                  <TableRow>
                    {columns.map((col, i) => (
                      <TableCell className={classes.capitalize} key={i}>
                        {col.field.toLowerCase() !== "image" && (
                          <TableSortLabel
                            active={currentSort.label === col.label}
                            direction={currentSort.direction}
                            onClick={() => handleSort(col.label)}
                          >
                            {col.label}
                          </TableSortLabel>
                        )}
                        {col.field.toLowerCase() === "image" && col.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>{columns.map(renderFilterColumns)}</TableRow>
                  {Object.keys(filters).length > 0 && (
                    <TableRow selected>
                      <TableCell colSpan={columns.length} align="center">
                        <Typography variant="h6" component="p">
                          Selected filters: &nbsp;
                        </Typography>
                        {Object.keys(filters).map((filter, i) => {
                          return (
                            <React.Fragment key={i}>
                              <Chip
                                variant="outlined"
                                color="primary"
                                onDelete={() => {
                                  handleDeleteChip(filter);
                                }}
                                label={
                                  <>
                                    <b className={classes.capitalize}>
                                      {filter}
                                    </b>
                                    : {filters[filter]}
                                  </>
                                }
                              />
                              &nbsp; &nbsp;
                            </React.Fragment>
                          );
                        })}
                        <Chip
                          color="primary"
                          icon={<SearchIcon />}
                          className={classes.chipButton}
                          clickable
                          onClick={() => handleQuery()}
                          label={<b>Search</b>}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                  {meetings.map((meeting, index) => (
                    <TableRow
                      hover
                      key={meeting.id}
                      onClick={() => handleRowClick(index)}
                    >
                      {renderDataColumns(meeting, columns)}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </PerfectScrollbar>
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            component="div"
            count={meetingCount}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </CardActions>
      </Card>
      <Dialog
        open={imageModal}
        onBackdropClick={e => setImageModal(false)}
        onEscapeKeyDown={e => setImageModal(false)}
      >
        <img style={{ width: "100%" }} src={imageModalurl} />
      </Dialog>
    </div>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  meetings: PropTypes.array.isRequired
};

Results.defaultProps = {
  meetings: []
};

export default Results;
